import React from "react";

export function TokenCapture() {
  React.useEffect(() => {
    let redirectTarget = "/";

    const isSafeRedirect = (urlStr) => {
      if (!urlStr || typeof urlStr !== "string") return false;
      if (/^https?:\/\//i.test(urlStr)) return true;
      if (urlStr.startsWith("/")) return true;
      return false;
    };

    try {
      const url = new URL(window.location.href);
      const redirectTo = url.searchParams.get("redirectTo");
      if (redirectTo && isSafeRedirect(redirectTo)) {
        redirectTarget = redirectTo;
      }
    } catch (e) {
      // no-op
    } finally {
      window.location.replace(redirectTarget);
    }
  }, []);

  return <div style={{ padding: 16 }}>Redirecting...</div>;
}
